import { usePeopleFiltersContext } from '@sales-app/context/peopleFilters/peopleFilters'
import { CorporateLeadQueries } from '@sales-app/graphql/queries/corporateLeads.queries'
import { GET_CORPORATE_LEADS } from '@sales-app/types/CorporateLead'
import { useDebounce } from '@shared/hooks'

import { useGraphql } from '@/hooks/useGraphql'

export const useCorporateLeads = () => {
  const { searchString } = usePeopleFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)
  const corporateLeadQuery = useGraphql<GET_CORPORATE_LEADS.Response>(
    CorporateLeadQueries.getCorporateLeads.name,
    CorporateLeadQueries.getCorporateLeads(),
    { filter: { search: debouncedSearch } },
  )

  return corporateLeadQuery
}
